
import { toast } from "sonner";
import WarningIcon from "@mui/icons-material/Warning";
import Alert from "@mui/joy/Alert";
import IconButton from "@mui/joy/IconButton";
import Button from "@mui/joy/Button";
import Stack from "@mui/joy/Stack";
import Typography from "@mui/joy/Typography";
import IdentityAvatar from 'components/IdentityAvatar';


import getIcon from 'utils/getIcon';

const enhancedToast = toast as typeof toast & { warn: typeof toast["message"] };

enhancedToast.warn = (message, data) =>
  toast(message, {
    ...data,
    className: "sonner-toast-warn",
    icon: <WarningIcon />
  });

export function Error(s: string) {
    enhancedToast.error(s);
}

export function Success(s: string) {
    console.log("SUCCESS", s);
    enhancedToast.success(s);
}

export function Warn(s: string) {
    enhancedToast.warn(s);
}

function getAvatar(identity_uuid: string) {
    if(identity_uuid) {
        return <IdentityAvatar size="inline" identityKey={identity_uuid} />;
    }
    return null;
}

export function SimpleMessage(body: string) {
    enhancedToast.message(body);
}

export function Message(body?: string, identityKey?: string, buttonText?: string, onClick?: () => void, duration?: number) {

    const avatar = getAvatar(identityKey || '');

    const Close = getIcon('Close');


    enhancedToast.custom((t) => (
        <Alert
            variant="outlined"
            sx={{ minWidth: "350px" }}

            startDecorator={
                <IconButton
                    variant="plain"
                    color="neutral"
                    onClick={() => toast.dismiss(t)}
                >
                    <Close />
                </IconButton>
            }
        >
            <Stack spacing={1} sx={{ width: "100%" }}>
                <Stack sx={{ width: "100%" }}>
                    {avatar}
                    {body &&
                        <Typography>
                            {body}
                        </Typography>}
                </Stack>
                {buttonText && onClick &&
                    <Stack direction="row"
                        justifyContent="flex-end">
                        <Button
                            variant="soft"
                            color="success"
                            onClick={() => { toast.dismiss(t); onClick && onClick() }}
                        >{buttonText}</Button>
                    </Stack>}
            </Stack>
        </Alert>), { duration: duration || Infinity });
}


export default enhancedToast;
